/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} User_Change_Password_TitleInputs */

const vi_user_change_password_title = /** @type {(inputs: User_Change_Password_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đổi mật khẩu — ${i?.name}`)
};

/**

* @param {User_Change_Password_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_change_password_title = /** @type {((inputs: User_Change_Password_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Change_Password_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_change_password_title(inputs)
});